/**
 * 数据中心 → 配料机数据 → 物料损耗
 * parent = coffee_menu XTSeriesData 1776875108514795520
 * 注：不可用 990421（已占用 ecosystemMallTopology）
 */
export const DISPENSER_MATERIAL_LOSS_MENU_IDS = {
  page: 991133,
  enName: 'dispenserMaterialLoss',
  parentEnName: 'XTSeriesData',
  parentId: 1776875108514795520
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/dispenserMaterialLoss.js